<template>
  <div class="result">
    <c-result-game-info
      v-if="state === 'finished'"
      :data="store.getters['results/ownRanking']"
      data-qe-id="game-info"
    />
    <c-result-game-pending
      v-else-if="state === 'pending'"
      :data="store.getters['results/ownRanking']"
      data-qe-id="game-pending"
    />
    <c-result-game-skip-game
      v-else-if="state === 'skipgame'"
      :data="store.getters['results/ownRanking']"
      @contact-customer-service="onCustomerServiceContact"
      data-qe-id="game-skipped"
    />
    <c-result-game-lto v-else-if="state === 'lto'" :data="store.getters['results/ownRanking']" data-qe-id="game-lto" />

    <div class="narrow-container">
      <div class="result-navigation-section">
        <c-tech-hint
          v-if="store.state.results.current.nextGame"
          :gametype="store.state.results.current.gametype"
          :techs="store.getters['results/tournamentSupportedGameTechs']"
        >
          <template v-slot:default="status">
            <t-button :inactive="status.block" @click="onPlay(status.block)" yellow data-qe-id="play-button">
              {{ $t('resultView.buttons.play') }}
            </t-button>
          </template>
        </c-tech-hint>
        <t-button @click="onTournament" lightGray data-qe-id="back-button">{{
          $t('resultView.buttons.back')
        }}</t-button>
      </div>
    </div>

    <c-result-table :data="store.getters['results/rankingTable']" :state="state" data-qe-id="ranking-table" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import CResultGameInfo from '@/components/CResultGameInfo.vue'
import CResultGamePending from '@/components/CResultGamePending.vue'
import CResultGameLto from '@/components/CResultGameLto.vue'
import CResultGameSkipGame from '@/components/CResultGameSkipGame.vue'
import CResultTable from '@/components/CResultTable.vue'
import { CsFormPreselections, getSubTopic } from '@/lib/customerService'
import { ERROR_CODES } from '@/model/ErrorCodes'

const props = defineProps<{ competitionId: string }>()
const router = useRouter()
const store = useStore()

function created() {
  store.dispatch('results/fetchCompetitionResultById', props.competitionId).catch((err) => {
    if (err && err.errorCode === 401) {
      router.replace('/extern/login')
    } else {
      router.push({
        path: `/error/${(err && err.errorCode) || ERROR_CODES.UNKNOWN}/${store.getters['results/zoneId']}`,
      })
    }
  })
}

const state = computed(() => {
  return store.state.results.current.state
})

function onTournament() {
  router.push('/tournaments/' + store.getters['results/zoneId'])
}

function onPlay(blocked: boolean) {
  if (blocked) {
    return
  }
  const tournamentId = store.getters['results/tournamentId']
  router.push(`/matching/${store.getters['results/zoneId']}/${tournamentId}`)
}

function onCustomerServiceContact() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(store.getters['results/zoneId']),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}

created()
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.result {
  padding-bottom: 5.625em;
  .narrow-container {
    margin: auto;
  }
}
.result-navigation-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 1em auto 4.5em;
  .t-button {
    margin: 0 0.5em;
  }
}
</style>
